import { atom } from 'jotai'
import type { TCountryFeelgreat } from '@repo/unicity'

export { countryState } from '@repo/unicity'
export type { TCountry, TCountryFeelgreat } from '@repo/unicity'

export type TFeelGreatCountriesResponse = {
    success: boolean
    data: Record<string, TCountryFeelgreat[]>
}

export const feelgreatCountriesAtom = atom<TFeelGreatCountriesResponse | null>(null)
export const isLoadingFeelgreatCountriesAtom = atom<boolean>(false)

export const allFeelgreatCountriesAtom = atom<TCountryFeelgreat[]>(get => {
    const response = get(feelgreatCountriesAtom)
    if (!response?.data) return []
    return Object.values(response.data).filter(Array.isArray).flat() as TCountryFeelgreat[]
})

export const feelgreatCountryAtom = atom<TCountryFeelgreat | null>(null)
